export const BREADCRUMB_BASE_ITEMS = {
  home: { title: 'Scaler', link: '/' },
  review: { title: 'Scaler Review', link: '/review/' },
};

export const BREADCRUMB_ADDITIONAL_ITEMS = {
  'data-science-course': {
    title: 'Data Science and Machine Learning',
    link: '/data-science-course/reviews/',
  },
};
